import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views/dist";
import BankExportDetailView from "../bankExportDetailView";
import DistributorRefundExportDetailViewModel from "viewModels/finance/bankExports/distributorRefundExports/distributorRefundExportDetailViewModel";

const DistributorRefundExportDetailView: ViewComponent<DistributorRefundExportDetailViewModel> = observer(({ vm }) => {
  return <BankExportDetailView vm={vm} />;
});

registerView(DistributorRefundExportDetailView, DistributorRefundExportDetailViewModel);
